import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import userDetail from "Stores/userDetail";
import BreadCrumbComponent from "Components/common/breadcrumb";
import UserFilterDropdown from "./LiveFeed/Components/UserFilterDropdown";
import DashboardState from "./mainState";
import DashboardV2 from "./DashboardV2/DashboardV2";
// import TasksModule from "./TasksModule/main";
import DashboardHeader from "./DashboardV2/DashboardHeader/DashboardHeader";
import DashboardTabsSkeleton from "./DashboardV2/DashboardHeader/DashboardTabsSkeleton";
import DateFilter from "./DashboardV2/DateFilter/DateFilter";
import LiveFeed from "./LiveFeed/main";
import widgetDataStore from "./DashboardV2/store/widgetDataStore";
import dashboardV2Store from "./DashboardV2/store/dashboardV2Store";
import { initialWelcomePopupState } from "Components/common/InitialWelcomePopup";

const Dashboard = observer(props => {
  const breadcrumbArr = [
    {
      name: "Dashboards",
      link: "/dashboard"
    }
  ];
  const {
    team = false,
    memberId = "",
    hasTeamMember = false,
    isTeamOwner = false
  } = userDetail?.userInfo || {};

  const { noOfSequencesUsed = 0, isOnBoardingCompleted = false } =
    userDetail.userFeatureFlag || {};

  const getSelectedUsers = obj => {
    const memberIds =
      obj && typeof obj === "object" && Object.keys(obj)?.length > 0
        ? obj
        : obj?.length && obj?.toLowerCase() === "you"
          ? new Array(memberId)
          : "";
    return memberIds;
  };

  const getSelectedUser = value => {
    const selectedIds = getSelectedUsers(value);
    DashboardState.setMemberId(selectedIds);
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const dashboardContainerRef = useRef(null);
  const hasPinnedWidgets = dashboardV2Store.activeDashboard?.widgets?.some(w => w.pinned) || false;

  const handleDashboardScroll = e => {
    const el = e.target;
    setIsScrolled(el.scrollTop > 0);
    setShowBottomShadow(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
  };

  useEffect(() => {
    const el = dashboardContainerRef.current;
    if (el) setShowBottomShadow(el.scrollHeight > el.clientHeight);
  }, [dashboardV2Store.activeDashboard?.widgets?.length]);

  useEffect(() => {
    const isWelcomePopupShown = localStorage.getItem("isWelcomePopupShown");
    if (
      !isOnBoardingCompleted &&
      !isWelcomePopupShown &&
      !noOfSequencesUsed > 0
    ) {
      localStorage.setItem("isWelcomePopupShown", true);
      initialWelcomePopupState.setShowPopup(true);
    }
    return () => {
      DashboardState.setMemberId("");
    };
  }, []);

  return (
    <section className="dashboardPage">
      <div className="headerSection">
        <BreadCrumbComponent breadCrumbValue={breadcrumbArr} />
      </div>
      <div className="dashboardWrapper">
        <div className={`filterSectionWrap${isScrolled ? " filterSectionWrapScrolled" : ""}`}>
          <div className="filterSectionInner">
            <div className="dashboardTabsContainer">
              {dashboardV2Store.isLoadingDashboards ? (
                <DashboardTabsSkeleton />
              ) : (
                <DashboardHeader />
              )}
            </div>
            <div className="topFilter">
              <DateFilter
                activeFilter={widgetDataStore.activeDateFilter}
                onSelect={preset => widgetDataStore.setDateFilter(preset)}
              />
              {((team && hasTeamMember?.length > 1) || isTeamOwner) && (
                <UserFilterDropdown
                  team={team}
                  selectedUserCbk={getSelectedUser}
                />
              )}
            </div>
          </div>
        </div>
        <div className="dashboardContainer" ref={dashboardContainerRef} onScroll={handleDashboardScroll}>
          <div className="leftSection">
            <DashboardV2 />
            {/* <TasksModule /> */}
          </div>
          <div className={`rightSectionWrap${hasPinnedWidgets ? " rightSectionWrapWithPinned" : ""}`}>
            <div className="rightSection liveFeedSettingBarWeb">
              <LiveFeed />
            </div>
          </div>
        </div>
        {showBottomShadow && <span className="dashboardContainerShadowBottom" />}
      </div>
    </section>
  );
});

export default withRouter(Dashboard);
export { Dashboard };
